// Utilidades compartidas del módulo «Día a día»
import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from '../fs';
import { db } from '../firebase';

export const hoyISO = (d = new Date()) => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid' }).format(d);
export const diaMenos = (n) => hoyISO(new Date(Date.now() - n * 864e5));
export const horaMadrid = (d = new Date()) => Number(new Intl.DateTimeFormat('es-ES', { hour: 'numeric', hour12: false, timeZone: 'Europe/Madrid' }).format(d));
export const hhmm = (iso) => (iso ? new Date(iso).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Madrid' }) : '');
export const diaHora = (iso) => (iso ? new Date(iso).toLocaleString('es-ES', { weekday: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Madrid' }) : '');
export const fDia = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }) : '');
export const eur = (v) => `${(Math.round((v || 0) * 100) / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
export const num = (v) => { const x = parseFloat(String(v ?? '').replace(',', '.')); return isNaN(x) ? null : x; };
export const tel = (t) => { const d = String(t || '').replace(/\D/g, ''); return d.length === 9 ? `34${d}` : d; };

// Suscripción a una colección filtrada por clínicas (+ filtros extra)
export function useColeccion(nombre, clinicas, filtros = [], activo = true) {
  const [l, setL] = useState(null);
  const clave = `${clinicas.join(',')}|${JSON.stringify(filtros)}|${activo}`;
  useEffect(() => {
    if (!activo || !clinicas.length) { setL([]); return undefined; }
    const q = query(collection(db, nombre), where('clinica', 'in', clinicas), ...filtros.map(([c, op, v]) => where(c, op, v)));
    return onSnapshot(q, (s) => setL(s.docs.map((d) => ({ id: d.id, ...d.data() }))), () => setL([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clave]);
  return l;
}

// Próxima toma de un tratamiento: la última dada (o el inicio) + cada X horas
export function proximaToma(t, tomas) {
  const dadas = (tomas || []).filter((x) => x.tid === t.id).map((x) => x.dada).sort();
  const ult = dadas[dadas.length - 1];
  const base = ult ? new Date(ult).getTime() + t.cadaH * 36e5 : new Date(t.inicio).getTime();
  return { proxima: new Date(base).toISOString(), ultima: ult || null };
}
export const estadoToma = (iso) => {
  const m = (new Date(iso).getTime() - Date.now()) / 6e4;
  return m < -30 ? 'tarde' : m < 60 ? 'ya' : 'luego';
};

// Rango legal habitual para la nevera de vacunas
export const NEVERA = { min: 2, max: 8 };

// Fuerza a repintar cada minuto (para que las tomas pasen a «toca ya» / «atrasada» solas)
export function useReloj(ms = 60000) {
  const [t, setT] = useState(Date.now());
  useEffect(() => { const i = setInterval(() => setT(Date.now()), ms); return () => clearInterval(i); }, [ms]);
  return t;
}
